/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetStudentProgressReportParams = {
  /**
   * Filter by student status: active, stalled, completed, all
   */
  status?: string;
  /**
   * Filter by module version
   */
  version?: string | null;
};
